import type { User, UserRole, TaskComment, OpsComment } from '../types';

const INTERNAL_MOD_ROLES: UserRole[] = ['admin', 'employee', 'staff'];

function isInternalModerator(role: UserRole): boolean {
  return INTERNAL_MOD_ROLES.includes(role);
}

/** Own comment, or internal moderators may remove marketing request thread comments. */
export function canDeleteMarketingRequestComment(
  user: User | null,
  comment: { userId?: string },
): boolean {
  if (!user?.id) return false;
  if (String(comment.userId ?? '') === String(user.id)) return true;
  return isInternalModerator(user.role);
}

/** Own comment, or internal staff (admin / employee / field staff) may remove task thread comments. */
export function canDeleteTaskComment(user: User | null, comment: TaskComment): boolean {
  if (!user?.id) return false;
  // Suppliers may create Production comments; rules allow reaction-only updates, not delete.
  if (user.role === 'supplier') return false;
  if (String(comment.authorId ?? '') === String(user.id)) return true;
  return isInternalModerator(user.role);
}

/** Own comment, or internal moderators may remove ops thread comments. */
export function canDeleteOpsComment(user: User | null, comment: OpsComment): boolean {
  if (!user?.id) return false;
  if (String(comment.userId ?? '') === String(user.id)) return true;
  return isInternalModerator(user.role);
}

/** Own portal PDF pin, or CRM admins may remove client comments on portal deliverables. */
export function canDeletePortalPdfAnnotation(
  user: User | null,
  annotationAuthorUid: string,
): boolean {
  if (!user?.id) return false;
  if (String(annotationAuthorUid) === String(user.id)) return true;
  return user.role === 'admin';
}
